<template>
  <div class="project"  :class="{'project-preview' : mode === 'PREVIEW'}">
    <div class="container">
      <div class="project-index">0{{ index }}</div>
      <div class="project-images">
        <img class="image-web" :src="project.images[0]"/>
        <img class="image-web-small" :src="project.images[1]"/>
        <img class="image-mobile" :src="project.images[2]"/>
      </div>
      <div class="project-info">
        <div class="project-name">{{ project.name }}</div>
        <div class="project-description">{{ project.short_description }}</div>
        <div class="project-more" @click="setPreviewMode"> More</div>
      </div>
      <div class="project-detailed-info">
        <div class="project-name">{{ project.name }}</div>
        <p>{{ project.short_description }}</p>
        <p>{{ project.short_description }}</p>
        <p>{{ project.short_description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Project",
    props: {
      project: {},
      index: {}
    },

    data() {
      return {
        mode: 'INFO'
      }
    },

    methods: {
      setPreviewMode() {
        this.mode = 'PREVIEW';
      }
    }
  }
</script>

<style lang="scss">
  @import "src/components/Project";
</style>
